// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3g8Ac","content":"Consent_content__6-QNJ","footer":"Consent_footer__VzYUT"};